/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import {TOKEN_EXPIRED} from "../hooks/useAPIHelper";

const GET_CUSTOMER_URL = '/.netlify/functions/cusGetCustomers';

const GetCustomer = async (token: string, filter: string) => {

  const fetchData = async (): Promise<any> => {
    try {
      const customerRes = await axios({
        method: 'POST',
        url: GET_CUSTOMER_URL,
        headers: {
          'Content-Type': 'application/xml',
          'X-Pronto-Token': token,
        },
        data: filter
      });

      if (customerRes.status === 200) {
        if (customerRes.data.CusGetCustomersResponse.Customers.Customer) {
          return customerRes.data.CusGetCustomersResponse.Customers.Customer;
        } else {
          return 'empty';
        }
      }
    } catch (err) {
      if(err.response.status == 401) {
        if(err.response.data == 'TokenExpired') {
          throw(TOKEN_EXPIRED)
        }
      }
      console.log(err);
    }
  };

  return await fetchData();
};

export default GetCustomer;
